import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyBitcoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6.5 6h8a3 3 0 0 1 0 6m0 0a3 3 0 0 1 0 6h-8m8-6h-6m0-6v12m1-15v3m4-3v3m-4 12v3m4-3v3"
    />
  </svg>
);
export default SvgCurrencyBitcoin;
